/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Balance info per asset
 */
export interface AssetBalanceInfo {
  asset: Asset;
  total: number;
  totalInUsd: number;
}
